


























import Vue from 'vue';

import { REQUEST_TYPE } from '@/config';
import SamplesDialog from '@/components/ui/dialogs/samples-dialog/samples-dialog.vue';

import { BUTTON_COLORS } from '../../config';

export default Vue.extend({
  name: 'MainMenu',

  components: {
    SamplesDialog,
  },

  props: {
    tab: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    buttons: [
      {
        label: 'Your Top Listened',
        color: BUTTON_COLORS.yellow,
        key: REQUEST_TYPE.TOP_LISTENED,
        icon: 'mdi-poll',
      },
      {
        label: 'Liked Songs',
        color: BUTTON_COLORS.blue,
        key: REQUEST_TYPE.LIKED_SONGS,
        icon: 'mdi-heart',
      },
      {
        label: 'Playlists',
        color: BUTTON_COLORS.purple,
        key: REQUEST_TYPE.PLAYLISTS,
        icon: 'mdi-playlist-music-outline',
      },
      {
        label: 'Albums',
        color: BUTTON_COLORS.green,
        key: REQUEST_TYPE.ALBUMS,
        icon: 'mdi-album',
      },
      {
        label: 'Artists',
        color: BUTTON_COLORS.red,
        key: REQUEST_TYPE.ARTISTS,
        icon: 'mdi-account',
      },
    ],
  }),

  methods: {
    select(key: string) {
      this.$emit('select', key);
    },
  },
});
